import React from 'react';
import './AvatarGroup.css';

interface AvatarGroupProps {
  avatars: string[];
  maxVisible?: number;
  size?: number;
}

const AvatarGroup: React.FC<AvatarGroupProps> = ({
  avatars,
  maxVisible = 3,
  size = 28
}) => {
  const visibleAvatars = avatars.slice(0, maxVisible);
  const remaining = avatars.length - maxVisible;

  return (
    <div className="avatar-group">
      {visibleAvatars.map((src, i) => (
        <img
          key={i}
          src={src}
          alt={`avatar-${i}`}
          className="avatar"
          style={{ width: size, height: size, zIndex: avatars.length - i }}
        />
      ))}
      {remaining > 0 && (
        <div
          className="avatar avatar-count"
          style={{
            width: size,
            height: size,
            lineHeight: `${size}px`
          }}
        >
          +{remaining}
        </div>
      )}
    </div>
  );
};

export default AvatarGroup;
